<template>
    <views class="map">
        <nav-bar
            title="位置导航"
            fixed
            @click-left="onClickLeft">
        </nav-bar>
        <views class="map-filter">
            <div class="inner">
                <views class="icon">
                    <views class="icon-start"></views>
                    <views class="icon-end"></views>
                </views>
                <views class="name">
                    <views :class="{'active': isToggle}" class="list map-filter-from">
                        {{ fromName}}
                    </views>
                    <views class="line"></views>
                    <views :class="{'active': isToggle}" class="list map-filter-to" @click="searchShop">
                        {{ toName }}
                    </views>
                </views>
                <views class="toggle" @click="handleToggle">
                    <images :src="toggleIcon"></images>
                </views>
            </div>
        </views>
        <views v-if="isRender" class="map-body">
            <el-amap
                class="amap-box"
                :vid="'shop-detail2'"
                :amap-manager="amapManager"
                :plugin="plugin"
                :events="events"
                :zoom="10">
            </el-amap>
        </views>
    </views>
</template>

<script>
import VueAMap from 'vue-amap'
import NavBar from '@/components/navBar'
import tools from '@/mixins/tools'
import wx from 'weixin-jsapi'
const amapManager = new VueAMap.AMapManager()
export default {
    components: {
        NavBar
    },
    mixins: [tools],
    props: {
    },
    data() {
        return {
            isRender: false,
            isToggle: false, // 切换起始点
            fromName: '我的位置',
            toName: '',
            amapManager,
            driving: null,
            events: {
                init: (o) => {
                    // const startLngLat = [parseFloat(storage.get('curLng')), parseFloat(storage.get('curLat'))]
                    // const endLngLat = [parseFloat(this.endLng), parseFloat(this.endLat)]
                    // const startLngLat = [parseFloat('39.72684'), parseFloat('116.34159')]
                    // const endLngLat = [parseFloat(117.20901489257812), parseFloat(39.13272339930893)]
                    // AMap.plugin('AMap.Driving', () => {
                    //     this.driving = new AMap.Driving({
                    //         // 驾车路线规划策略，AMap.DrivingPolicy.LEAST_TIME是最快捷模式
                    //         policy: AMap.DrivingPolicy.LEAST_TIME,
                    //         map: this.amapManager.getMap()
                    //     })
                    //     this.loading('加载中...', true)
                    //     this.search(startLngLat, endLngLat)
                    // })
                },
                moveend: () => {
                },
                zoomchange: () => {
                },
                click: (e) => {
                    // alert('map clicked')
                }
            },
            plugin: [],
            toggleIcon: require('@/assets/images/toggle.png')
        }
    },
    computed: {
        query() {
            return this.$route.query
        },
        endLng() {
            return this.query.endLng
        },
        endLat() {
            return this.query.endLat
        }
    },
    watch: {
        endLng: {
            handler(val) {
                this.toName = this.query.toName
            },
            immediate: true
        }
    },
    mounted() {
        // 起始点
        this.startLngLat = null
        // 本地开发测试
        if (process.env.NODE_ENV === 'development') {
            const res = { latitude: 40.211583, longitude: 116.593244 }
            this.events.init = this.createInit(res)
            this.isRender = true
        } else {
            wx.ready((e) => {
                console.log('readyreadyreadyreadyreadyready', e)
                this.getLoacationPos().then(res => {
                    this.events.init = this.createInit(res)
                    this.isRender = true
                })
            })
        }
    },
    methods: {
        createInit(res) {
            this.startLngLat = [parseFloat(res.longitude), parseFloat(res.latitude)]
            return (o) => {
                // const startLngLat = [parseFloat(storage.get('curLng')), parseFloat(storage.get('curLat'))]
                // latitude: 39.72684, longitude: 116.34159
                // const startLngLat = [parseFloat('39.72684'), parseFloat('116.34159')]
                const startLngLat = this.startLngLat
                const endLngLat = [parseFloat(this.endLng), parseFloat(this.endLat)]
                console.log(startLngLat, endLngLat)
                AMap.plugin('AMap.Driving', () => {
                    this.driving = new AMap.Driving({
                        // 驾车路线规划策略，AMap.DrivingPolicy.LEAST_TIME是最快捷模式
                        policy: AMap.DrivingPolicy.LEAST_TIME,
                        map: this.amapManager.getMap()
                    })
                    this.loading('加载中...', true)
                    this.search(startLngLat, endLngLat)
                })
            }
        },
        onClickLeft() {
            this.back()
            // this.windowPush(`/shop?posP=${this.query.posP}&posC=${this.query.posC}&pid=${this.query.pid}&cid=${this.query.cid}`)
        },
        handleToggle() {
            this.loading('加载中...', true)
            this.clear()
            let startLngLat = null
            let endLngLat = null
            if (!this.isToggle) {
                startLngLat = [parseFloat(this.endLng), parseFloat(this.endLat)]
                endLngLat = this.startLngLat
            } else {
                startLngLat = this.startLngLat
                endLngLat = [parseFloat(this.endLng), parseFloat(this.endLat)]
            }
            this.search(startLngLat, endLngLat, true)
        },
        // 清除路线
        clear() {
            this.driving.clear()
        },
        // 查询路线
        search(startLngLat, endLngLat, toggle = false) {
            if (startLngLat && endLngLat) {
                this.driving.search(startLngLat, endLngLat, (status, result) => {
                    // 未出错时，result即是对应的路线规划方案
                    if (status === 'complete') {
                        if (toggle) this.isToggle = !this.isToggle
                    } else {
                        this.notify('查询路线失败')
                    }
                    this.hideLoading()
                })
            }
        },
        // 搜索门店
        searchShop() {
            this.push(`/search?to=map-navigation&endLng=${this.endLng}&endLat=${this.endLat}&toName=${this.query.toName}&placeholder=搜索门店`)
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
